import React, { useState, useEffect, useCallback } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Select from 'react-select';

// --- Función de ayuda para formatear fechas (CORREGIDA) ---
const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    
    // Creamos el objeto Date a partir de la cadena que viene del servidor.
    const date = new Date(dateString);
    
    // Extraemos los componentes de la fecha usando métodos UTC.
    // Esto ignora la zona horaria del navegador.
    const year = date.getUTCFullYear();
    const month = (date.getUTCMonth() + 1).toString().padStart(2, '0'); // getUTCMonth() es 0-11, por eso +1
    const day = date.getUTCDate().toString().padStart(2, '0');
    
    // Devolvemos la fecha formateada correctamente.
    return `${day}/${month}/${year}`;
};

// --- FUNCIÓN getDateInfo (RESTAURADA A LA VERSIÓN CORRECTA Y VALIDADA) ---
const getDateInfo = (fechaVencimientoString, estado, fechaCompletadoString) => {
    if (estado === 'Completada') {
        const completadoUTC = new Date(fechaCompletadoString);
        const vencimientoUTC = new Date(fechaVencimientoString);
        const completadoDia = new Date(Date.UTC(completadoUTC.getUTCFullYear(), completadoUTC.getUTCMonth(), completadoUTC.getUTCDate()));
        const vencimientoDia = new Date(Date.UTC(vencimientoUTC.getUTCFullYear(), vencimientoUTC.getUTCMonth(), vencimientoUTC.getUTCDate()));
        if (completadoDia.getTime() > vencimientoDia.getTime()) {
            return { color: 'text-danger fw-bold', label: 'Completada (Tarde)' };
        }
        return { color: 'text-success', label: estado };
    }

    // --- Lógica de zona horaria que sí funciona ---
    const hoyEnMazatlan = new Date(new Date().toLocaleString("en-US", { timeZone: "America/Mazatlan" }));
    const hoyMedianocheUTC = new Date(Date.UTC(
        hoyEnMazatlan.getFullYear(),
        hoyEnMazatlan.getMonth(),
        hoyEnMazatlan.getDate()
    ));

    const vencimientoUTC = new Date(fechaVencimientoString + 'T00:00:00Z');

    if (vencimientoUTC.getTime() < hoyMedianocheUTC.getTime()) {
        return { color: 'text-danger fw-bold', label: 'Vencida' };
    }
    
    const diffTime = vencimientoUTC.getTime() - hoyMedianocheUTC.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    // --- Lógica de 3 días restaurada ---
    if (diffDays <= 3) {
        return { color: 'text-warning', label: 'Pendiente' };
    }

    return { color: '', label: estado };
};

// --- Estilos para los nuevos selectores con scroll ---
const customSelectStyles = {
  menu: (provided) => ({
    ...provided,
    zIndex: 9999
  }),
  menuList: (provided) => ({
    ...provided,
    maxHeight: '200px', // Altura máxima antes de mostrar scroll
    overflowY: 'auto'
  }),
};

// --- Componente de Paginación ---
const Pagination = ({ currentPage, totalPages, onPageChange }) => {
    const pageNumbers = [];
    const maxPagesToShow = 5;
    let startPage, endPage;

    if (totalPages <= maxPagesToShow) {
        startPage = 1;
        endPage = totalPages;
    } else {
        const maxPagesBeforeCurrent = Math.floor(maxPagesToShow / 2);
        const maxPagesAfterCurrent = Math.ceil(maxPagesToShow / 2) - 1;
        if (currentPage <= maxPagesBeforeCurrent) {
            startPage = 1;
            endPage = maxPagesToShow;
        } else if (currentPage + maxPagesAfterCurrent >= totalPages) {
            startPage = totalPages - maxPagesToShow + 1;
            endPage = totalPages;
        } else {
            startPage = currentPage - maxPagesBeforeCurrent;
            endPage = currentPage + maxPagesAfterCurrent;
        }
    }

    for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(i);
    }

    return (
        <nav>
            <ul className="pagination pagination-sm mb-0">
                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => onPageChange(1)}>«</button>
                </li>
                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => onPageChange(currentPage - 1)}>‹</button>
                </li>
                {pageNumbers.map(number => (
                    <li key={number} className={`page-item ${currentPage === number ? 'active' : ''}`}>
                        <button className="page-link" onClick={() => onPageChange(number)}>{number}</button>
                    </li>
                ))}
                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => onPageChange(currentPage + 1)}>›</button>
                </li>
                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => onPageChange(totalPages)}>»</button>
                </li>
            </ul>
        </nav>
    );
};


function VistaSistemaActsis() {
    const { sistemaId } = useParams();
    const { token, user: currentUser } = useAuth();
    
    const [tareas, setTareas] = useState([]);
    const [updatingTaskId, setUpdatingTaskId] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [mensaje, setMensaje] = useState({ texto: '', tipo: '' });
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [filtroEstado, setFiltroEstado] = useState('Todos');
    const [filtroUsuarioId, setFiltroUsuarioId] = useState('Todos');
    const [filtroMarca, setFiltroMarca] = useState('todas');
    const [filtroAgencia, setFiltroAgencia] = useState('todas');
    const [filtroTrabajoId, setFiltroTrabajoId] = useState('todos');
    const [vistaActual, setVistaActual] = useState('actual');
    const [usuariosDelSistema, setUsuariosDelSistema] = useState([]);
    const [listaAgencias, setListaAgencias] = useState([]);
    const [listaTrabajos, setListaTrabajos] = useState([]);

    
    useEffect(() => {
        const fetchFilterData = async () => {
            if (!token) return;
            try {
                const headers = { 'Authorization': `Bearer ${token}` };
                const [usuariosRes, agenciasRes, trabajosRes] = await Promise.all([
                    currentUser.rol === 'admin' ? fetch(`/api/sistemas/${sistemaId}/usuarios`, { headers }) : Promise.resolve({ ok: true, json: () => Promise.resolve([]) }),
                    fetch('/api/agencias-accesibles', { headers }),
                    fetch('/api/trabajos', { headers })
                ]);

                if (!usuariosRes.ok || !agenciasRes.ok || !trabajosRes.ok) throw new Error('No se pudo cargar la información para los filtros.');
                
                const usuariosData = await usuariosRes.json();
                const agenciasData = await agenciasRes.json();
                const trabajosData = await trabajosRes.json();
                
                setUsuariosDelSistema(usuariosData);
                setListaAgencias(agenciasData);
                setListaTrabajos(trabajosData);

            } catch (err) {
                setError(err.message);
            }
        };
        fetchFilterData();
    }, [token, sistemaId, currentUser.rol]);

    const fetchTareas = useCallback(async () => {
        if (!token) return;
        setLoading(true);
        setError('');

        const params = new URLSearchParams({
            page: currentPage,
            limit: itemsPerPage,
            estado: filtroEstado,
            usuarioId: filtroUsuarioId,
            vista: vistaActual,
            marca: filtroMarca,
            agenciaId: filtroAgencia,
            trabajoId: filtroTrabajoId,
        });

        try {
            const response = await fetch(`/api/actsis/${sistemaId}/tareas?${params.toString()}`, {
                headers: { 'Authorization': `Bearer ${token}` },
                cache: 'no-store'
            });
            if (!response.ok) {
                const errData = await response.json();
                throw new Error(errData.message || 'Error al cargar las tareas');
            }
            const data = await response.json();
            setTareas(data.tareas);
            setTotalPages(data.totalPages);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    }, [token, sistemaId, currentPage, itemsPerPage, filtroEstado, filtroUsuarioId, vistaActual, filtroMarca, filtroAgencia, filtroTrabajoId]);

    useEffect(() => {
        fetchTareas();
    }, [fetchTareas]);
    
    const handlePageChange = (page) => {
        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);
        }
    };
    
    const handleEstadoChange = (nuevoEstado) => {
        setFiltroEstado(nuevoEstado);
        setCurrentPage(1);
    };

    const handleVistaChange = (nuevaVista) => {
        setVistaActual(nuevaVista);
        if (nuevaVista === 'historico') {
            setFiltroEstado('Completada');
        } else {
            setFiltroEstado('Todos');
        }
        setCurrentPage(1);
    };

    const handleLimpiarFiltros = () => {
        setVistaActual('actual');
        setFiltroEstado('Todos');
        setFiltroUsuarioId('Todos');
        setFiltroMarca('todas');
        setFiltroAgencia('todas');
        setFiltroTrabajoId('todos');
        setCurrentPage(1);
    };

    const handleItemsPerPageChange = (event) => {
        setItemsPerPage(Number(event.target.value));
        setCurrentPage(1);
    };

    const handleUpdateTaskStatus = async (tareaId, nuevoEstado) => {
        if (nuevoEstado === 'Pendiente' && !window.confirm('¿Estás seguro de que deseas reabrir esta tarea?')) {
            return;
        }
        try {
            const response = await fetch(`/api/actsis/tareas/${tareaId}/estado`, {
                method: 'PUT',
                headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
                body: JSON.stringify({ estado: nuevoEstado }),
            });
            const data = await response.json();
            if (!response.ok) {
                throw new Error(data.message || `Error al marcar la tarea como ${nuevoEstado.toLowerCase()}.`);
            }
            fetchTareas();
        } catch (error) {
            alert(`Error: ${error.message}`);
        }
    };

    const handleMarcarComoCompletada = async (tarea) => {
        if (tarea.estado === 'Completada') return;
        try {
            const response = await fetch(`/api/actsis/tareas/${tarea.asignacion_id}/estado`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                body: JSON.stringify({ estado: 'Completada' }),
            });
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Error al completar la tarea.');
            }
            fetchTareas();
            setMensaje({ texto: `✅ Tarea "${tarea.titulo}" completada.`, tipo: 'exito' });
        } catch (error) {
            setMensaje({ texto: `❌ Error: ${error.message}`, tipo: 'error' });
        }
    };

    const handleSubtareaChange = async (tareaId, subtareaId, completadaActual) => {
        setUpdatingTaskId(tareaId);
        try {
            setTareas(prevTareas => prevTareas.map(tarea => {
                if (tarea.id === tareaId) {
                    return {
                        ...tarea,
                        subtareas: tarea.subtareas.map(st =>
                            st.id === subtareaId ? { ...st, completada_por_usuario: !st.completada_por_usuario } : st
                        )
                    };
                }
                return tarea;
            }));
            const response = await fetch(`/api/actsis/subtareas/${subtareaId}`, {
                method: 'PUT',
                headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
                body: JSON.stringify({ completada: !completadaActual })
            });
            if (!response.ok) {
                fetchTareas();
                const data = await response.json();
                throw new Error(data.message || 'Error al actualizar la subtarea.');
            }
        } catch (error) {
            setMensaje({ texto: `❌ Error: ${error.message}`, tipo: 'error' });
        } finally {
            setUpdatingTaskId(null);
        }
    };
    
    const marcasDisponibles = [...new Set(listaAgencias.map(ag => ag.marca))];
    const agenciasFiltradasPorMarca = filtroMarca === 'todas' ? listaAgencias : listaAgencias.filter(ag => ag.marca === filtroMarca);
    
    const marcaOptions = [
        { value: 'todas', label: 'Todas las Marcas' },
        ...marcasDisponibles.map(marca => ({ value: marca, label: marca }))
    ];

    const agenciaOptions = [
        { value: 'todas', label: 'Todas las Agencias' },
        ...agenciasFiltradasPorMarca.map(agencia => ({ value: agencia.id.toString(), label: agencia.nombre }))
    ];
    
    const userOptions = [
        { value: 'Todos', label: 'Todos los Usuarios' },
        ...usuariosDelSistema.map(user => ({ value: user.id.toString(), label: user.nombre }))
    ];
    
    const trabajoOptions = [
        { value: 'todos', label: 'Todos los Trabajos' },
        ...listaTrabajos.map(trabajo => ({ value: trabajo.id.toString(), label: trabajo.nombre }))
    ];
    
    const handleMarcaChange = (selectedOption) => {
        setFiltroMarca(selectedOption.value);
        setFiltroAgencia('todas');
    };

    const handleAgenciaChange = (selectedOption) => {
        setFiltroAgencia(selectedOption.value);
    };

    const handleUserChange = (selectedOption) => {
        setFiltroUsuarioId(selectedOption.value);
    };

    const handleTrabajoChange = (selectedOption) => {
        setFiltroTrabajoId(selectedOption.value);
    };

    return (
        <div className="container-fluid mt-4 px-4">
            <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-2">
                <div>
                    <h2 className="mb-0">Actividades del Sistema</h2>
                </div>
                <div>
                    <Link to={`/sistemas/${sistemaId}/dashboard`} className="btn btn-outline-secondary me-2">
                        Dashboard
                    </Link>
                    <Link to={`/sistemas/${sistemaId}/crear-actividad`} className="btn btn-primary">
                        + Crear Nueva Actividad
                    </Link>
                </div>
            </div>

            {error && <div className="alert alert-danger">{error}</div>}

            <div className="card shadow-sm mb-4 small">
                <div className="card-body">
                    <div className="row g-2 align-items-center">
                        <div className="col-12 col-lg-auto">
                            <div className="btn-group" role="group">
                                <button type="button" className={`btn btn-outline-warning ${filtroEstado === 'Pendiente' ? 'active' : ''}`} onClick={() => handleEstadoChange('Pendiente')} disabled={vistaActual === 'historico'}>Pendientes</button>
                                <button type="button" className={`btn btn-outline-success ${filtroEstado === 'Completada' ? 'active' : ''}`} onClick={() => handleEstadoChange('Completada')}>Completadas</button>
                                <button type="button" className={`btn btn-outline-danger ${filtroEstado === 'Vencida' ? 'active' : ''}`} onClick={() => handleEstadoChange('Vencida')} disabled={vistaActual === 'historico'}>Vencidas</button>
                                <button type="button" className={`btn btn-outline-secondary ${filtroEstado === 'Todos' ? 'active' : ''}`} onClick={() => handleEstadoChange('Todos')} disabled={vistaActual === 'historico'}>Todas</button>
                            </div>
                        </div>
                        <div className="col-12 col-lg-auto">
                           <div className="btn-group" role="group">
                               <button type="button" className={`btn btn-outline-info ${vistaActual === 'actual' ? 'active' : ''}`} onClick={() => handleVistaChange('actual')}>Vista Actual</button>
                               <button type="button" className={`btn btn-outline-info ${vistaActual === 'historico' ? 'active' : ''}`} onClick={() => handleVistaChange('historico')}>Histórico</button>
                           </div>
                        </div>
                        <div className="col-12 col-md-6 col-lg-1">
                            <Select
                                options={marcaOptions}
                                styles={customSelectStyles}
                                value={marcaOptions.find(option => option.value === filtroMarca)}
                                onChange={handleMarcaChange}
                                placeholder="Filtrar por Marca..."
                                isSearchable={true}
                            />
                        </div>
                         <div className="col-12 col-md-6 col-lg-1">
                            <Select
                                options={agenciaOptions}
                                styles={customSelectStyles}
                                value={agenciaOptions.find(option => option.value === filtroAgencia)}
                                onChange={handleAgenciaChange}
                                placeholder="Filtrar por Agencia..."
                                isSearchable={true}
                            />
                        </div>
                        <div className="col-12 col-md-6 col-lg-1">
                            <Select
                                options={trabajoOptions}
                                styles={customSelectStyles}
                                value={trabajoOptions.find(option => option.value === filtroTrabajoId)}
                                onChange={handleTrabajoChange}
                                placeholder="Filtrar por Trabajo..."
                                isSearchable={true}
                            />
                        </div>
                        {(currentUser.rol === 'admin') && (
                            <div className="col-12 col-md-6 col-lg-1">
                                <Select
                                    options={userOptions}
                                    styles={customSelectStyles}
                                    value={userOptions.find(option => option.value === filtroUsuarioId)}
                                    onChange={handleUserChange}
                                    placeholder="Filtrar por Usuario..."
                                    isSearchable={true}
                                    isDisabled={currentUser.rol !== 'admin'}
                                />
                            </div>
                        )}
                        <div className="col-12 col-lg-auto">
                            <button className="btn btn-outline-primary w-100" onClick={handleLimpiarFiltros}>
                                Limpiar Filtros
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {loading ? (
                <div className="text-center"><div className="spinner-border" role="status"><span className="visually-hidden">Cargando...</span></div></div>
            ) : (
                <>
                    <div className="accordion" id="accordionTareas">
                        {tareas.length > 0 ? tareas.map((tarea) => {
                            const subtareasPendientes = tarea.subtareas ? tarea.subtareas.filter(s => !s.completada_por_usuario).length : 0;
                            const todasSubtareasCompletadas = subtareasPendientes === 0;
                            const dateInfo = getDateInfo(tarea.fecha_vencimiento, tarea.estado, tarea.fecha_completado);
                            
                            const totalSubtareas = tarea.subtareas?.length || 0;
                                let progreso = {
                                    porcentaje: 0,
                                    completadas: 0,
                                    mostrar: totalSubtareas > 0
                                };

                                if (progreso.mostrar) {
                                    progreso.completadas = tarea.subtareas.filter(s => s.completada_por_usuario).length;
                                    progreso.porcentaje = Math.round((progreso.completadas / totalSubtareas) * 100);
                                }

                            return (
                                <div className="accordion-item" key={tarea.asignacion_id}>
                                    <h2 className="accordion-header" id={`heading-${tarea.asignacion_id}`}>
                                        <button 
                                            className="accordion-button collapsed" 
                                            type="button" 
                                            data-bs-toggle="collapse" 
                                            data-bs-target={`#collapse-${tarea.asignacion_id}`} 
                                            aria-expanded="false" 
                                            aria-controls={`collapse-${tarea.asignacion_id}`}
                                        >
                                            <div className="d-flex w-100 align-items-center gap-3">
                                                <div style={{ flex: '1 1 0%', minWidth: 0 }}>
                                                    <div className="fw-bold">{tarea.titulo}</div>
                                                    <div className="small text-muted">{tarea.descripcion || ''}</div>
                                                    {progreso.mostrar && (
                                                        <div style={{ width: '200px', marginTop: '0.5rem' }}>
                                                            <small className="text-muted" style={{ fontSize: '0.8em' }}>
                                                                Avance: {progreso.completadas} de {totalSubtareas} ({progreso.porcentaje}%)
                                                            </small>
                                                            <div className="progress" style={{ height: '15px' }}>
                                                                <div className="progress-bar bg-success" role="progressbar" style={{ width: `${progreso.porcentaje}%` }}></div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="d-flex gap-4 text-nowrap align-items-center" style={{ flexShrink: 0, fontSize: '0.8em' }}>
                                                    <div>
                                                        <div className="text-muted text-uppercase small">Trabajo</div>
                                                        <div className="fw-bold">{tarea.trabajo_nombre}</div>
                                                    </div>
                                                    <div>
                                                        <div className="text-muted text-uppercase small">Agencia</div>
                                                        <div className="fw-bold">{tarea.agencia_nombre}</div>
                                                    </div>
                                                    <div>
                                                        <div className="text-muted text-uppercase small">Asignado a</div>
                                                        <div className="fw-bold">{tarea.usuario_nombre_asignado}</div>
                                                    </div>
                                                    <div>
                                                        <div className="text-muted text-uppercase small">Creado por</div>
                                                        <div className="fw-bold">{tarea.usuario_nombre_creado}</div>
                                                    </div>
                                                    <div className="d-flex align-items-center">
                                                    <div>
                                                        <div className={`text-muted text-uppercase small ${dateInfo.color}`}>Vence</div>
                                                        <div className={`fw-bold ${dateInfo.color}`}>{formatDate(tarea.fecha_vencimiento)}</div>
                                                    </div>
                                                        {dateInfo.label === 'Vencida' && (<span className="badge bg-danger ms-2">Vencida</span>)}
                                                        {dateInfo.label === 'Completada' && (<span className="badge bg-success ms-2">Completada</span>)}
                                                        {dateInfo.label === 'Completada (Tarde)' && (<span className="badge bg-success ms-2">Completada (Tarde)</span>)}
                                                        {dateInfo.label === 'Pendiente' && (<span className="badge bg-warning ms-2">Pendiente</span>)}
                                                </div>
                                                </div>
                                            </div>
                                        </button>
                                    </h2>
                                    <div id={`collapse-${tarea.asignacion_id}`} className="accordion-collapse collapse" aria-labelledby={`heading-${tarea.asignacion_id}`} data-bs-parent="#accordionTareas">
                                        <div className="accordion-body">
                                            {tarea.subtareas && tarea.subtareas.length > 0 && (
                                                <div className="mt-3">
                                                    <h6>Subtareas:</h6>
                                                    <ul className="list-group">
                                                        {tarea.subtareas.map(subtarea => (
                                                            <li key={subtarea.id} className="list-group-item d-flex align-items-center">
                                                                <input 
                                                                    className="form-check-input me-2" 
                                                                    type="checkbox" 
                                                                    checked={subtarea.completada_por_usuario || false} 
                                                                    onChange={() => handleSubtareaChange(tarea.id, subtarea.id, subtarea.completada_por_usuario)}
                                                                    id={`subtarea-${subtarea.id}-${tarea.asignacion_id}`}
                                                                    disabled={tarea.estado === 'Completada'}
                                                                />
                                                                <span className={subtarea.completada_por_usuario ? 'text-muted text-decoration-line-through' : ''}>
                                                                    {subtarea.titulo}
                                                                </span>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            )}
                                            <div className="mt-3 d-flex gap-2 justify-content-end">
                                                    {tarea.estado === 'Pendiente' && (
                                                        <button
                                                            className="btn btn-sm btn-outline-success"
                                                            onClick={() => handleMarcarComoCompletada(tarea)}
                                                            disabled={!todasSubtareasCompletadas || updatingTaskId === tarea.id}
                                                            title={
                                                                updatingTaskId === tarea.id 
                                                                ? 'Guardando subtarea...' 
                                                                : !todasSubtareasCompletadas 
                                                                ? 'Completa todas las subtareas primero' 
                                                                : 'Marcar como completada'
                                                            }
                                                        >
                                                            {updatingTaskId === tarea.id ? 'Espere...' : 'Marcar como Completada'}
                                                        </button>
                                                    )}
                                                {tarea.estado === 'Completada' && (
                                                        <button
                                                            className="btn btn-warning btn-sm"
                                                            onClick={() => handleUpdateTaskStatus(tarea.asignacion_id, 'Pendiente')}
                                                        >
                                                            Reabrir Tarea
                                                        </button>
                                                    )}
                                                {(currentUser.rol === 'admin' || tarea.creado_por_usuario_id === currentUser.id) && (
                                                    <Link to={`/sistemas/${sistemaId}/editar-actividad/${tarea.id}`} className="btn btn-info btn-sm">
                                                        Editar Tarea
                                                    </Link>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        }) : <p className="text-center text-muted">No se encontraron actividades.</p>}
                    </div>

                    {totalPages > 0 && (
                        <div className="d-flex flex-wrap justify-content-center align-items-center mt-4 gap-3">
                            <div className="d-flex align-items-center">
                                <label htmlFor="itemsPerPageSelect" className="form-label me-2 mb-0">Mostrar:</label>
                                <select 
                                    id="itemsPerPageSelect"
                                    className="form-select form-select-sm" 
                                    value={itemsPerPage} 
                                    onChange={handleItemsPerPageChange}
                                    style={{ width: 'auto' }}
                                >
                                    <option value="10">10</option>
                                    <option value="25">25</option>
                                    <option value="50">50</option>
                                </select>
                            </div>
                            <Pagination 
                                currentPage={currentPage} 
                                totalPages={totalPages} 
                                onPageChange={handlePageChange} 
                            />
                        </div>
                    )}
                </>
            )}
        </div>
    );
}

export default VistaSistemaActsis;